// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import XngZone from "@awc/App/Components/Common/XngZone";
import { XNGAGE_ELEMENTS } from "@awc/XDL/constants";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";

const enum fields {
    shadowColor = "shadowColor",
    showBoxShadow = "showBoxShadow",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.shadowColor]: string;
        [fields.showBoxShadow]: boolean;
    };
}

export interface ContainerStyles {
    wrapper?: InjectableCss;
}

export const containerStyles: ContainerStyles = {};

type Props = OwnProps;
const styles = containerStyles;
const Container: FC<Props> = ({ fields, id }) => {
    return (
        <StyledWrapper
            {...styles.wrapper}
            {...{ shadowColor: fields.shadowColor, showBoxShadow: fields.showBoxShadow }}
        >
            <XngZone contentId={id} zoneName="ContainerWithShadow" />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: Container,
    definition: {
        displayName: "Container",
        group: XNGAGE_ELEMENTS,
        fieldDefinitions: [
            {
                name: fields.shadowColor,
                displayName: "Shadow Color",
                editorTemplate: "ColorPickerField",
                defaultValue: "#ee7623",
                fieldType: "General",
            },
            {
                name: fields.showBoxShadow,
                displayName: "Show Box Shadow",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
